import script from "./SovaClubThanks.vue?vue&type=script&setup=true&lang=js"
export * from "./SovaClubThanks.vue?vue&type=script&setup=true&lang=js"

import "./SovaClubThanks.vue?vue&type=style&index=0&id=ea53e5d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea53e5d0"]])

export default __exports__